<template>
<div class="singlePost">

<div class="latestInfoEntry">
  <p class="timestamp"> Friday, February 16th 2024 </p>
  <h4>Tanisha's Story</h4>
<p><em>Eats on Feets Missouri Volunteer</em></p>
    <img class="blogImage blogImage-right" src="../../assets/TanishaClay.png" />
<p><strong>My Background</strong></p>
<p>I’m a first time mom to a little boy. We spent hundreds with specialists, trying to make nursing work, but ultimately I ended up having to pump. Through the pumping process, I learned that I had a significant oversupply. I pumped for 10 months (720 hours I spent tied to a pump... but who’s counting?!) After my kiddo was diagnosed with a dairy allergy at 6 weeks old, I had lots of milk leftover that was completely unusable.. I knew right away that I wanted to donate to caregivers in need. On top of that, being able to provide dairy-free milk to other allergy babes was a huge blessing as well. In total, I was able to help feed 13 babies at one point or another between regular + emergency donations during my breastfeeding journey.</p>
<p><strong>My Motivation for Volunteering</strong></p>
<p>I know that it takes volunteers on every side of this to make it work (donors volunteering their time to pump + bag, admins and moderators volunteering their time to run the pages, and owners volunteering their time and energy to ensure that the program works as it should). I was thankful to be able to contribute in another way, as I believe that milksharing is a monumental testament of “It takes a village”.
</p>
<p><strong>My Life</strong></p>
<p>I’m a first-time mama to a 1.5 year old boy. My husband and I have been together for 8 years; we have two doggos + a cat, and spend most of our ‘free’ time doing things as a family. I’m a photographer, executive assistant, and virtual assistant, and the biggest carb enthusiast you will meet!
</p>
<ul>
    <li><strong>Favorite Dish:</strong> Texas Roadhouse Bread + Butter (usually, way too much)</li>
    <li><strong>Favorite Past-time:</strong> Reading the same book 100 times to my toddler</li>
    <li><strong>Favorite Animal:</strong> Doggos!</li>
    <li><strong>Bucket List Item:</strong> Explore Greece!</li>
</ul>
</div>
</div>
</template>
<script>
export default {
  name: 'TanishaMissouriVolunteer'
}
</script>

<style lang="scss">
.references {
  font-size: .8em;
}
</style>

<style lang="scss">
.references {
  font-size: .8em;
}
</style>
